export default [
  {
    path: '/',
    redirect: '/download/index',
  },
  {
    path: '/download/index',
    name: 'download',
    component: () => import(/* webpackChunkName: 'scan-payment' */ '@v/Index.vue'),
    meta: {
      title: '客户端历史版本',
    },
  },
];
